import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const responsiblePartyTypesAdapter = getAdapter({ idFieldName: 'value' });

const responsiblePartyTypesSlice = createSlice({
    name: 'responsiblePartyTypes',
    initialState: responsiblePartyTypesAdapter.getInitialState(),
    reducers: {
        setResponsiblePartyTypes: (state, { payload: { responsiblePartyTypes } }) => {
            responsiblePartyTypesAdapter.setAll(state, responsiblePartyTypes);
        },
    },
});

const selectors = responsiblePartyTypesAdapter.getSelectors(({ responsiblePartyTypes }) => responsiblePartyTypes);

export const getAllResponsiblePartyTypes = (state) => selectors.selectAll(state);

export const {
    setResponsiblePartyTypes,
} = responsiblePartyTypesSlice.actions;

export default responsiblePartyTypesSlice.reducer;
